var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c('recess-link',{staticClass:"product-link link",style:(_vm.style),attrs:{"to":_vm.documentPath(_vm.product)}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }